import objectPath from 'object-path';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import { useDefineUserRole, useFormatMessage } from '../../../app/hooks';
import { actions as productCatalogActions } from '../../../app/store/ducks/product-catalog.duck';
import { IAppState } from '../../../app/store/rootDuck';
import KTToggle from '../../_assets/js/toggle';
import * as builder from '../../ducks/builder';
import UserProfile from '../../partials/layout/UserProfile';
import { toAbsoluteUrl } from '../../utils/utils';
import { useModalCategory } from '../categories/categoryContext';

const useStyles = makeStyles()(theme => {
  return {
    btnCatalog: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 44,
      backgroundColor: '#6E94BB',
      borderRadius: 22,
      cursor: 'pointer',
      width: 100,
      [theme.breakpoints.down(600)]: {
        width: '100%',
        padding: '0 10px',
      },
    },
    catalogTitle: {
      fontSize: 16,
      fontWeight: theme.typography.fontWeightRegular,
      color: '#fff',
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    logo: {
      height: 35,
      width: 'auto',
    },
  };
});

const HeaderMobile = () => {
  const toggleButtonRef = React.useRef();
  const { classes } = useStyles();
  const { toggle } = useModalCategory();
  const fm = useFormatMessage();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { me, page, perPage, filter, isSearching } = useSelector((store: IAppState) => ({
    me: store.profile.me,
    page: store.productsCatalog.page,
    perPage: store.productsCatalog.per_page,
    filter: store.productsCatalog.filter,
    isSearching: store.productsCatalog.isSearching,
  }));

  const isVendor = useDefineUserRole(me, ['ROLE_VENDOR', 'ROLE_VENDOR_STAFF']);

  const handleLogoClick = React.useCallback(() => {
    navigate('/');
    if (isSearching) {
      dispatch(productCatalogActions.setSearching(''));
      dispatch(productCatalogActions.fetchRequest({ page, perPage, filter }));
    }
  }, [navigate, dispatch, isSearching, page, perPage, filter]);

  const { headerMobileCssClasses, headerMobileAttributes, headerMenuSelfDisplay } =
    useSelector((store: IAppState) => ({
      headerMobileCssClasses: builder.selectors.getClasses(store, {
        path: 'header_mobile',
        toString: true,
      }),
      headerMobileAttributes: builder.selectors.getAttributes(store, {
        path: 'aside_menu',
      }),
      headerMenuSelfDisplay:
        objectPath.get(store.builder.layoutConfig, 'header.menu.self.display') === true,
    }));

  useEffect(() => {
    KTToggle(toggleButtonRef.current, {
      target: 'body',
      targetState: 'kt-header__topbar--mobile-on',
      togglerState: 'kt-header-mobile__toolbar-topbar-toggler--active',
    });
  }, []);

  return (
    <div
      id='kt_header_mobile'
      className={`kt-header-mobile ${headerMobileCssClasses}`}
      {...headerMobileAttributes}
    >
      <div
        className='kt-header-mobile__toolbar'
        style={{
          flex: 0.4,
          display: 'flex',
          gap: 20,
          alignItems: 'center',
        }}
      >
        {headerMenuSelfDisplay && (
          <button
            className='kt-header-mobile__toggler'
            id='kt_header_mobile_toggler'
            style={{
              display: !isVendor && !me?.is_admin ? 'none' : undefined,
            }}
          >
            <span />
          </button>
        )}
        <div className={classes.logoContainer} onClick={handleLogoClick}>
          <img
            src={toAbsoluteUrl('/images/chipscan-ico@3x.png')}
            alt='logo'
            className={classes.logo}
          />
        </div>
        <div className={classes.btnCatalog} onClick={toggle}>
          <Typography component='p' className={classes.catalogTitle}>
            {fm('PRODUCT.CATALOG.TITLE')}
          </Typography>
        </div>
      </div>
      <div
        className='kt-header-mobile__toolbar'
        style={{
          justifyContent: 'flex-end',
        }}
      >
        <UserProfile showAvatar={true} />
      </div>
    </div>
  );
};

export default HeaderMobile;
